import { __rest, __assign } from './../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
import CssVariables from '../../theme/variables/CssVariables.js';
import Tooltip from './../../external_lib/antd/es/tooltip/index.js';

/**
 * Returns the UI status tag
 *
 * @param {StatusType} status Contains the status information text, textColor, backgroundColor,
 * @param {string} color To pass the color if the textColor value is not defined. Can be ( green, red, yellow, blue, gray, purple, steel-blue )
 * @param {CSSProperties} style Custom styles
 * @param {string} tooltip Content for tooltip
 */
function HorizonChip(_a) {
  var status = _a.status,
    _b = _a.containerProps,
    containerProps = _b === void 0 ? {} : _b,
    _c = _a.textProps,
    textProps = _c === void 0 ? {} : _c,
    color = _a.color,
    _d = _a.tooltip,
    tooltip = _d === void 0 ? null : _d,
    _e = _a.empty,
    empty = _e === void 0 ? null : _e,
    _f = _a.normalFont,
    normalFont = _f === void 0 ? false : _f,
    icon = _a.icon;
  _a.className;
  var rest = __rest(_a, ["status", "containerProps", "textProps", "color", "tooltip", "empty", "normalFont", "icon", "className"]);
  if (!status) {
    return empty;
  }
  function getColorCodes(colorCode) {
    switch (colorCode) {
      case 'red':
        return {
          textColor: CssVariables['--up-red-70'],
          backgroundColor: CssVariables['--up-red-10']
        };
      case 'blue':
        return {
          textColor: CssVariables['--up-blue-50'],
          backgroundColor: CssVariables['--up-blue-5']
        };
      case 'green':
        return {
          textColor: CssVariables['--up-green-70'],
          backgroundColor: CssVariables['--up-green-10']
        };
      case 'yellow':
        return {
          textColor: CssVariables['--up-yellow-70'],
          backgroundColor: CssVariables['--up-yellow-10']
        };
      case 'gray':
        return {
          textColor: CssVariables['--up-black-60'],
          backgroundColor: CssVariables['--up-black-5']
        };
      case 'purple':
        return {
          textColor: CssVariables['--up-purple-70'],
          backgroundColor: CssVariables['--up-purple-10']
        };
      case 'steel-blue':
        return {
          textColor: CssVariables['--up-steel-blue-70'],
          backgroundColor: CssVariables['--up-steel-blue-10']
        };
      default:
        return {
          textColor: CssVariables['--up-green-70'],
          backgroundColor: CssVariables['--up-green-10']
        };
    }
  }
  var customContainerStyle = __assign({
    background: status.backgroundColor || getColorCodes(color || '').backgroundColor,
    display: 'inline-flex',
    alignItems: 'center',
    padding: '2px 8px',
    borderRadius: 2
  }, containerProps.style);
  var customTextStyle = __assign({
    color: status.textColor || getColorCodes(color || '').textColor,
    fontWeight: normalFont ? 400 : 600,
    marginLeft: icon ? '4px' : '0px'
  }, textProps.style);
  var Component = React__default.createElement("div", __assign({
    className: containerProps.className || '',
    style: customContainerStyle
  }, rest), icon && React__default.createElement("span", {
    className: "inline-flex items-center"
  }, icon), React__default.createElement("span", {
    className: "inline-block text-xs ".concat(textProps.className || ''),
    style: customTextStyle
  }, status.text));
  if (!tooltip) {
    return Component;
  }
  return React__default.createElement(Tooltip, {
    title: tooltip
  }, Component);
}
export { HorizonChip as default };
//# sourceMappingURL=index.js.map
